import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripeKey) {
  console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY is not set');
}
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Elements stripe={stripePromise}>
    <App />
  </Elements>
);
